import { DeepMap } from 'react-hook-form';
import { JobsiteUpdateInput } from 'apollo/generated/client-operations';
import { ensureNonUndefinedFields } from 'utils';
import { FormInputTypes, TypedFormInputs } from 'components/form';
import { getFormOptions } from 'containers/jobsiteConfiguration/helpers/utils';
import {
  EditJobsiteConfigurationFormData,
  FormOptionElement,
} from 'containers/jobsiteConfiguration/types';
import { Jobsite, UserData } from './types';
import {
  getFormsSectionInputs,
  getFormsSectionDefaultValues,
  getFormsSectionUpdateInput,
} from './formsSection';

export type EditJobsiteConfigTabFormData = Pick<
  EditJobsiteConfigurationFormData,
  'forms'
>;

export type JobsiteSelectOptions = {
  formsOptions: FormOptionElement[];
};

export const getDropdownsOptions = (args: {
  userData: UserData;
}): JobsiteSelectOptions => {
  const { userData } = args;
  const forms = userData?.forms.edges.map(({ node }) => node) ?? [];

  return {
    formsOptions: getFormOptions(forms),
  };
};

type GetFormInputsArgs = JobsiteSelectOptions;

export const getFormInputs = (
  args: GetFormInputsArgs,
): TypedFormInputs<EditJobsiteConfigTabFormData> => {
  const { formsOptions } = args;

  const formsSectionInputs = getFormsSectionInputs({ formsOptions });

  return {
    forms: {
      element: FormInputTypes.Section,
      layout: '',
      elementProps: {
        title: 'Custom Logs',
        details: 'Configure custom logs for the jobsite',
      },
      children: formsSectionInputs,
    },
  };
};

type GetDefaultValuesArgs = {
  jobsite: Jobsite;
} & JobsiteSelectOptions;

export const getDefaultValues = (
  args: GetDefaultValuesArgs,
): EditJobsiteConfigTabFormData => {
  const { jobsite, formsOptions } = args;
  return {
    forms: getFormsSectionDefaultValues(jobsite, formsOptions),
  };
};

export const getJobsiteUpdateInput = (
  jobsite: Jobsite,
  data: EditJobsiteConfigTabFormData,
  dirtyFields: DeepMap<EditJobsiteConfigTabFormData, true>,
): JobsiteUpdateInput => {
  return ensureNonUndefinedFields<JobsiteUpdateInput>({
    jobsiteId: jobsite.jobsiteId,
    ...getFormsSectionUpdateInput(data.forms, dirtyFields.forms),
  });
};
